import axios from "axios";
import { SKILLS_URL } from "../utils";

export const fetchSkills = () => {
  return axios.get(SKILLS_URL);
};
